import { createContext, useState } from "react";

export const SearchContext = createContext() 

export const SearchProvider =  ({children})=>{
        const [age, setAge] = useState('');
        const [arrivDate, setArrivDate] = useState(null);
        const [departDate, setDepartDate] = useState(null);
        const [adult, setAdult] = useState(1);
        const [child, setChild] = useState(0);
        const [nbPlace, setNbPlace] = useState(1);

        const updateAge = (newAge)=>{
           setAge(newAge)
        }

        const  updateArrival = (newArrive)=>{
            setArrivDate(newArrive)
        }

        const updateDepart = (newDepar)=>{
            setDepartDate(newDepar)
        }

        const updateAdult = (newAdu)=>{
            setAdult(newAdu)
        }

        const updateChild = (newChil)=>{
            setChild(newChil)
        }

        const updateNbre = (newa, newc) => {
          // Utilisez parseInt et assurez-vous que les valeurs sont toujours des nombres
          const adultCount = isNaN(newa) ? 0 : parseInt(newa, 10);
          const childCount = isNaN(newc) ? 0 : parseInt(newc, 10);
          
          // Calculez le nombre total de places
          setNbPlace(adultCount + childCount);
      }

      return (
        <SearchContext.Provider value={{nbPlace ,updateNbre,age,arrivDate,departDate,adult,child,updateAge,updateArrival,updateDepart,updateChild,updateAdult}}>
          {children}
        </SearchContext.Provider>
      )
}
